import { Box, Container, Heading, Tag, Text, VStack } from "@chakra-ui/react";
import { HTTPError } from "ky";
import { DeveloperControls } from "components/developer-controls";
import { UnexpectedErrorContent } from "components/errors/components/unexpected-error-content";

export function ErrorScreen({ error }: { error: Error }) {
  const isDev = import.meta.env.DEV;
  let heading = "An error occurred";
  let description = "Please try again later.";
  let isClientError = false;

  if (error instanceof HTTPError) {
    if (error.response.status === 404) {
      isClientError = true;
      heading = "Listing or property not found";
      description =
        "The listing or property you are looking for does not exist.";
    }

    if (error.response.status === 401) {
      isClientError = true;
      heading = "You are not authorized to access this item";
      description =
        "Please contact your administrator if you believe this is an error.";
    }
  }

  return (
    <Container maxW={"2xl"} pt={"32"}>
      <VStack spacing={"4"} w={"100%"}>
        <Heading>{heading}</Heading>
        {isClientError ? (
          <Text>{description}</Text>
        ) : (
          <UnexpectedErrorContent error={error} />
        )}
        {isDev &&
        error instanceof HTTPError &&
        [404, 401].includes(error.response.status) ? (
          <Box
            borderColor={"orange.300"}
            borderWidth={2}
            w={"100%"}
            maxW={"400px"}
            bg={"orange.50"}
            borderStyle={"dashed"}
            p={4}
            borderRadius={4}
            textAlign={"center"}
            style={{
              // @ts-expect-error Exists
              textWrap: "balance",
            }}
          >
            <Text>
              <Tag colorScheme={"orange"} bgColor={"orange.300"} mr={2}>
                DEV
              </Tag>
              Check that the listing ID has been synced from CRM to Rex Home,
              and that the user/contact you are authenticating as is an agent or
              vendor for that listing.
            </Text>
            <Box
              ml={"auto"}
              mr={"auto"}
              mt={2}
              w={"300px"}
              display={"flex"}
              flexDir={"row"}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <DeveloperControls />
            </Box>
          </Box>
        ) : null}
      </VStack>
    </Container>
  );
}
